import ComedyImg from '@/assets/images/genres/comedy.jpg'
import DramaImg from '@/assets/images/genres/drama.jpg'
import HorrorImg from '@/assets/images/genres/horror.jpg'
import RomanceImg from '@/assets/images/genres/romance.jpg'
import SciFiImg from '@/assets/images/genres/sci-fi.jpg'
import ThrillerImg from '@/assets/images/genres/thriller.jpg'

type SubGenre = {
    label: string
}

type Genre = {
    label: string
    image: string
    subGenres: SubGenre[]
}

export const genresMap: Record<string, Genre> = {
    action: {
        label: 'Action',
        image: ComedyImg,
        subGenres: [
            { label: 'Martial Arts' },
            { label: 'Superhero' },
            { label: 'Adventure' },
            { label: 'War' },
        ],
    },
    comedy: {
        label: 'Comedy',
        image: ComedyImg,
        subGenres: [
            { label: 'Romantic Comedy' },
            { label: 'Slapstick' },
            { label: 'Satire' },
            { label: 'Dark Comedy' },
        ],
    },
    drama: {
        label: 'Drama',
        image: DramaImg,
        subGenres: [
            { label: 'Crime Drama' },
            { label: 'Historical Drama' },
            { label: 'Legal Drama' },
            { label: 'Melodrama' },
        ],
    },
    fantasy: {
        label: 'Fantasy',
        image: SciFiImg,
        subGenres: [
            { label: 'Epic Fantasy' },
            { label: 'Urban Fantasy' },
            { label: 'Dark Fantasy' },
            { label: 'Sword and Sorcery' },
        ],
    },
    horror: {
        label: 'Horror',
        image: HorrorImg,
        subGenres: [
            { label: 'Supernatural' },
            { label: 'Slasher' },
            { label: 'Psychological' },
            { label: 'Zombie' },
        ],
    },
    mystery: {
        label: 'Mystery',
        image: ThrillerImg,
        subGenres: [
            { label: 'Detective' },
            { label: 'Noir' },
            { label: 'Cozy Mystery' },
            { label: 'Thriller' },
        ],
    },
    romance: {
        label: 'Romance',
        image: RomanceImg,
        subGenres: [
            { label: 'Contemporary' },
            { label: 'Historical' },
            { label: 'Paranormal' },
            { label: 'Romantic Comedy' },
        ],
    },
    'sci-fi': {
        label: 'Science Fiction',
        image: SciFiImg,
        subGenres: [
            { label: 'Cyberpunk' },
            { label: 'Space Opera' },
            { label: 'Time Travel' },
            { label: 'Alien Invasion' },
        ],
    },
    thriller: {
        label: 'Thriller',
        image: ThrillerImg,
        subGenres: [
            { label: 'Psychological Thriller' },
            { label: 'Crime Thriller' },
            { label: 'Spy Thriller' },
            { label: 'Techno Thriller' },
        ],
    },
    documentary: {
        label: 'Documentary',
        image: ComedyImg,
        subGenres: [
            { label: 'Biography' },
            { label: 'Nature' },
            { label: 'Historical' },
            { label: 'True Crime' },
        ],
    },

    musical: {
        label: 'Musical',
        image: RomanceImg,
        subGenres: [
            { label: 'Broadway' },
            { label: 'Jukebox Musical' },
            { label: 'Rock Musical' },
            { label: 'Dance' },
        ],
    },
}

function add(a: number, b: number): number {
    return a + b
}
